import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import pendingIcon from '../../../theme/assets/svg/tc_cabinet_apostol_rewards_icon1.svg';
import availableIcon from '../../../theme/assets/svg/tc_cabinet_apostol_rewards_icon2.svg';
import receivedIcon from '../../../theme/assets/svg/tc_cabinet_apostol_rewards_icon3.svg';
import {formatWithSpaces} from "../../../helpers/formatSpace";
import {
    setReferralTransfersModalStatus,
    setReferralWithdrawModalStatus
} from "../../../store/cabinet/action";

const CabinetApostolRewards = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const referrals = useSelector(store => store.cabinet.referrals);

    // выводить нечего, пока реферальный баланс пуст
    const canTransfer = Number(referrals?.tokens?.available ?? referrals?.referral_balance ?? 0) > 0;

    const rows = [
        {
            icon: pendingIcon,
            name: t('Ожидают подтверждения'),
            value: referrals?.tokens?.pending ?? 0,
            color: Styles.valuePending
        },
        {
            icon: availableIcon,
            name: t('Доступно к выводу'),
            value: referrals?.tokens?.available ?? 0,
            color: Styles.valueAvailable
        },
        {
            icon: receivedIcon,
            name: t('Всего получено'),
            value: referrals?.tokens?.received ?? 0,
            color: Styles.valueReceived
        }
    ];

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardTitle}`}>{t('Ваши вознаграждения')}</div>

                    <div className={`${Styles.rowsWrap}`}>
                        {rows.map((item, index) => {
                            return (
                                <div className={`${Styles.rowItem}`} key={'apostol-reward_' + index}>
                                    <div className={`${Styles.rowItemIconWrap}`}>
                                        <img src={item.icon} alt=""/>
                                    </div>
                                    <div className={`${Styles.rowItemName}`}>{item.name}</div>
                                    <div className={`${Styles.rowItemValue} ${item.color}`}>{formatWithSpaces(item.value)} $TC</div>
                                </div>
                            )
                        })}
                    </div>

                    <div className={`${Styles.btnsWrap}`}>
                        {/* вознаграждения переезжают на основной баланс заявкой,
                            её подтверждает администратор */}
                        <div
                            className={`${Styles.cardBtn} ${Styles.cardBtnFill} ${!canTransfer ? Styles.cardBtnDisabled : ''}`}
                            title={!canTransfer ? t('Пока нечего выводить') : ''}
                            onClick={()=>{
                                if (canTransfer){
                                    dispatch(setReferralWithdrawModalStatus(true));
                                }
                            }}
                        >
                            {t('Вывести')}
                        </div>
                        <div
                            className={`${Styles.cardBtn}`}
                            onClick={()=>{dispatch(setReferralTransfersModalStatus(true))}}
                        >
                            {t('История выплат')}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetApostolRewards;
